(function ($) {
    "use strict";

    // The native <select>'s own open dropdown list can't be styled
    // consistently cross-browser — same problem 36_pm-property-filter.js
    // already solved, so this reuses its exact approach: progressively
    // enhance into a custom button + listbox, keeping the native <select>
    // around (visually hidden) purely to carry the form value/name.
    function enhanceSelect($wrap) {
        var $select = $wrap.find(".pm-lead-form__select");

        if (!$select.length || $wrap.data("pm-select-enhanced")) {
            return;
        }

        $wrap.data("pm-select-enhanced", true);

        var $chevron = $wrap.find(".pm-lead-form__select-chevron").detach();
        var $triggerLabel = $("<span>", { class: "pm-lead-form__select-trigger-label" });
        var $trigger = $("<button>", {
            type: "button",
            class: "pm-lead-form__select-trigger",
            "aria-haspopup": "listbox",
            "aria-expanded": "false",
        }).append($triggerLabel, $chevron);

        var $list = $("<ul>", {
            class: "pm-lead-form__select-list",
            role: "listbox",
        }).attr("hidden", true);

        function setTriggerLabel($option) {
            $triggerLabel
                .text($option.text())
                .toggleClass("pm-lead-form__select-trigger-label--placeholder", !$option.attr("value"));
        }

        $select.find("option").each(function () {
            var $option = $(this);

            // The empty disabled "Kérem válasszon" option drives the
            // trigger's placeholder label but isn't a real pickable item.
            if (!$option.attr("value")) {
                if ($option.is(":selected")) {
                    setTriggerLabel($option);
                }
                return;
            }

            var $item = $("<li>", {
                class: "pm-lead-form__select-option",
                role: "option",
                tabindex: "-1",
                text: $option.text(),
            }).attr("data-value", $option.attr("value"));

            if ($option.is(":selected")) {
                $item.addClass("is-selected");
                setTriggerLabel($option);
            }

            $list.append($item);
        });

        $select
            .attr("tabindex", "-1")
            .attr("aria-hidden", "true")
            .addClass("pm-lead-form__select--native-hidden");

        $wrap.append($trigger, $list);

        function closeList() {
            $list.attr("hidden", true);
            $trigger.attr("aria-expanded", "false");
        }

        function openList() {
            $(".pm-lead-form__select-list").not($list).attr("hidden", true);
            $(".pm-lead-form__select-trigger").not($trigger).attr("aria-expanded", "false");
            $list.removeAttr("hidden");
            $trigger.attr("aria-expanded", "true");
        }

        function selectOption($item) {
            $list.find(".is-selected").removeClass("is-selected");
            $item.addClass("is-selected");
            $triggerLabel.text($item.text()).removeClass("pm-lead-form__select-trigger-label--placeholder");
            $select.val($item.attr("data-value")).trigger("change");
        }

        $trigger.on("click", function (e) {
            e.stopPropagation();

            if ($list.attr("hidden")) {
                openList();
                var $selected = $list.find(".is-selected");
                ($selected.length ? $selected : $list.find(".pm-lead-form__select-option").first()).trigger("focus");
            } else {
                closeList();
            }
        });

        $list.on("click", ".pm-lead-form__select-option", function () {
            selectOption($(this));
            closeList();
            $trigger.trigger("focus");
        });

        $list.on("keydown", ".pm-lead-form__select-option", function (e) {
            var $items = $list.find(".pm-lead-form__select-option");
            var index = $items.index(this);

            if (e.key === "ArrowDown") {
                e.preventDefault();
                $items.eq(Math.min(index + 1, $items.length - 1)).trigger("focus");
            } else if (e.key === "ArrowUp") {
                e.preventDefault();
                $items.eq(Math.max(index - 1, 0)).trigger("focus");
            } else if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                selectOption($(this));
                closeList();
                $trigger.trigger("focus");
            } else if (e.key === "Escape") {
                e.preventDefault();
                closeList();
                $trigger.trigger("focus");
            } else if (e.key === "Tab") {
                closeList();
            }
        });

        $trigger.on("keydown", function (e) {
            if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                openList();
                var $selected = $list.find(".is-selected");
                ($selected.length ? $selected : $list.find(".pm-lead-form__select-option").first()).trigger("focus");
            }
        });
    }

    // Opens/closes a .pm-lead-form-modal the same way 37_pm-contact-card.js
    // does for the contact popup: any element carrying
    // .js-pm-lead-form-toggle opens it (optionally targeting a specific
    // instance via data-modal-target="<id>", otherwise falls back to the
    // first .js-pm-lead-form-modal on the page); .js-pm-lead-form-close
    // (the backdrop, the X button, and "Mégse") always closes it.
    $(function () {
        $(".pm-lead-form__select-wrap").each(function () {
            enhanceSelect($(this));
        });

        $(document).on("click", function () {
            $(".pm-lead-form__select-list").attr("hidden", true);
            $(".pm-lead-form__select-trigger").attr("aria-expanded", "false");
        });

        $(document).on("click", ".js-pm-lead-form-toggle", function (e) {
            e.preventDefault();

            var targetId = $(this).data("modal-target");
            var $modal = targetId ? $("#" + targetId) : $(".js-pm-lead-form-modal");

            $modal.addClass("is-open");
        });

        $(document).on("click", ".js-pm-lead-form-close", function (e) {
            e.preventDefault();

            $(this).closest(".js-pm-lead-form-modal").removeClass("is-open");
        });

        // Clicks inside the panel itself shouldn't bubble to the backdrop's
        // close-on-click-outside behavior — but that stopPropagation() also
        // prevents the plain document click handler above from ever running
        // for clicks inside the panel, so any open select list needs closing
        // here too (unless the click is on the select itself).
        $(document).on("click", ".pm-lead-form-modal__panel", function (e) {
            e.stopPropagation();

            if (!$(e.target).closest(".pm-lead-form__select-wrap").length) {
                $(".pm-lead-form__select-list").attr("hidden", true);
                $(".pm-lead-form__select-trigger").attr("aria-expanded", "false");
            }
        });

        // "Ingatlan paraméterei" stays in the DOM at all times, just
        // toggled via .is-visible depending on the has_own_flat radio.
        $(document).on("change", ".js-pm-lead-form-has-flat", function () {
            var $form = $(this).closest("form");
            var showPropertyFields = $form.find(".js-pm-lead-form-has-flat:checked").val() === "yes";

            $form.find(".js-pm-lead-form-property-fields").toggleClass("is-visible", showPropertyFields);
        });
    });
})(jQuery);
